import { Send, Mail, ShieldAlert } from "lucide-react";
import { useEffect, useState } from "react";
import { api, LOGO_URL, TELEGRAM_URL } from "@/lib/api";
import { Link } from "react-router-dom";

const DEFAULT_DISCLAIMER =
  "Cowboy Apps provides app rebranding services only. Cowboy Apps does not provide, host, supply, or sell any content, channels, playlists, or streams of any sort, and does not condone or support the use or sale of illegal content.";

export const Footer = () => {
  const [disclaimer, setDisclaimer] = useState(DEFAULT_DISCLAIMER);

  useEffect(() => {
    api.get("/settings/disclaimer")
      .then(({ data }) => data.text && setDisclaimer(data.text))
      .catch(() => {});
  }, []);

  return (
  <footer data-testid="site-footer" className="border-t border-[#282836] bg-[#0C0C12]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14">
      <div data-testid="legal-disclaimer" className="flex items-start gap-4 border border-[#282836] bg-[#12121A] rounded-2xl px-6 py-5">
        <ShieldAlert className="w-5 h-5 text-[#FF5500] shrink-0 mt-0.5" />
        <p className="text-sm text-[#9E9EB3] leading-relaxed">
          <span className="text-[#F4F4F8] font-semibold">Disclaimer:</span> {disclaimer}
        </p>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
        <div>
          <img src={LOGO_URL} alt="Cowboy Apps" className="h-16 w-auto mb-4" />
          <p className="text-[#63637A] text-sm max-w-xs">
            Popular IPTV apps rebranded with your logo — your name, your colors, your brand.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <a data-testid="footer-telegram-link" href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 text-[#9E9EB3] hover:text-[#FF5500] transition-colors">
            <Send className="w-4 h-4" /> @cowboyapps on Telegram
          </a>
          <a data-testid="footer-email-link" href="mailto:info@cowboyapps.net" className="inline-flex items-center gap-3 text-[#9E9EB3] hover:text-[#FF5500] transition-colors">
            <Mail className="w-4 h-4" /> info@cowboyapps.net
          </a>
          <Link data-testid="footer-admin-link" to="/admin" className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#63637A] hover:text-white transition-colors">
            Admin login
          </Link>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-[#282836] flex flex-wrap items-center justify-between gap-4">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#63637A]">
          © {new Date().getFullYear()} Cowboy Apps — All rights reserved
        </p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#63637A]">
          Ride on.
        </p>
      </div>
    </div>
  </footer>
  );
};
